import React from 'react'
import AdminOrganizations from "../../Admin/Organizations"

const AdminOrganizationsdiv = () => {
  return (
    <div>
      <AdminOrganizations/>
    </div>
  )
}

export default AdminOrganizationsdiv
